module.exports = new __parcel__URL__("icons8-react-native.7158eafa.svg").toString();